module.exports = __webpack_public_path__ + "img/Doctor_payment.a37fca56.svg";